var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-btn',{attrs:{"text":""},on:{"click":function($event){$event.preventDefault();return _vm.logOut.apply(null, arguments)}}},[_c('v-icon',[_vm._v("mdi-logout")]),_vm._v(" Salir ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }